import DiamondSvgSrc from "@icons/diamond-cta.svg?url";
import { Trans } from "@lingui/react/macro";

import {
  Button,
  PlanUpgradeCta,
} from "@/routes/shared/components/plan-upgrade-cta/plan-upgrade-cta";

const CallToAction = ({ onClick }: { onClick: () => void }) => {
  return (
    <PlanUpgradeCta
      description={
        <Trans>Sledujte historický vývoj cen komodit a měnových kurzů.</Trans>
      }
      heading={<Trans>Burzovní informace</Trans>}
      icon={
        <img
          className="h-12 w-12 sm:h-6 sm:w-6 @max-sm:h-12 @max-sm:w-12"
          src={DiamondSvgSrc}
        />
      }
    >
      <Button onClick={onClick}>
        <Trans>Chci plnou verzi</Trans>
      </Button>
    </PlanUpgradeCta>
  );
};

export { CallToAction };
